<mat-card>
  <mat-card-content>
    <p>User was successfully signed out.</p>
  </mat-card-content>
</mat-card>
